import { ReactNode } from 'react'

import styles from './LanguageOptionLabel.module.scss'

// Flag emoji are not rendered on Windows (Chrome shows "GB"), so use image flags.
export default function LanguageOptionLabel({
  flag,
  children,
}: {
  flag: 'gb' | 'no' | 'se'
  children: ReactNode
}) {
  return (
    <span className={styles.container}>
      <img
        className={styles.flag}
        src={`/images/flags/${flag}.svg`}
        alt=""
        width={18}
        height={14}
      />
      {children}
    </span>
  )
}
